import * as React from 'react';
import { Redirect } from 'react-router-dom'

export default class NotFoundLayout extends React.Component {
  render() {
    return (
      <div>
        <Redirect to='/' /> 
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/NotFoundLayout.tsx